import { SLACE_GENDERS } from 'cpool-constants';
import { z } from 'zod';

import { schemaSlaceCommunicationChannel } from '../SlaceCommunicationChannel';
import { schemaSlaceContactAddress } from '../SlaceContactAddress';
import { schemaSlaceCoupon } from '../SlaceCoupon';
import { schemaSlaceSegment } from '../SlaceSegment';

// https://docs.slace.com/docs/stoplight-docs-core/8541ae79cb720-create-new-contact#response-body
export const schemaCreateContactResponse = z.object({
    active: z.boolean(),
    address: schemaSlaceContactAddress.optional(),
    age: z.number().optional(),
    avatars: z
        .object({
            additional: z.record(z.string(), z.string()).optional(),
            primary: z.string().optional(),
        })
        .optional(),
    // Default is yyyy-mm-dd
    birthdate: z.string().optional(),
    care_of: z.string().optional(),
    com_channels: z.array(schemaSlaceCommunicationChannel).optional(),
    consent_keys: z.array(z.string()),
    coupons: z.array(schemaSlaceCoupon).optional(),
    created_at: z.string(),
    // Overridden with birthdate data if provided
    day_of_birth: z.number().optional(),
    devices: z.object({}).optional(),
    email: z.string().optional(),
    er_confidence: z
        .object({
            first_name: z.number().optional(),
            gender: z.number().optional(),
            last_name: z.number().optional(),
            title: z.number().optional(),
        })
        .optional(),
    external_ids: z.record(z.unknown()).optional(),
    external_links: z
        .object({
            system_name: z.string(),
            user_link: z.string(),
        })
        .optional(),
    first_name: z.string().optional(),
    formal: z.boolean().optional(),
    gender: z.nativeEnum(SLACE_GENDERS).optional(),
    given_consents: z.object({ last_given_at: z.string().optional(), version: z.number().optional() }).optional(),
    id: z.string(),
    import_batch_id: z.string().optional(),
    languages: z
        .object({
            additional: z.record(z.string(), z.string()).optional(),
            primary: z.string().optional(),
        })
        .optional(),
    last_active_at: z.string().optional(),
    last_name: z.string().optional(),
    lifetime_loyalty_points: z.record(z.string(), z.number()).optional(),
    loyalty_points: z.record(z.string(), z.number()).optional(),
    mobile: z.string().optional(),
    mobile_devices: z.object({}).optional(),
    mobile_verified: z.boolean().optional(),
    mobile_verified_at: z.string().optional(),
    // Overridden with birthdate data if provided
    month_of_birth: z.number().optional(),
    name: z.string(),
    organization_id: z.string(),
    segments: z.array(schemaSlaceSegment).optional(),
    status: z.string(),
    strict_attributes: z
        .record(
            z.string(),
            z.object({
                type: z.union([z.string(), z.number(), z.date()]),
                value: z.unknown(),
            }),
        )
        .optional(),
    timezone: z.string().optional(),
    title: z.string().optional(),
    updated_at: z.string(),
});

export type SchemaCreateContactResponse = z.infer<typeof schemaCreateContactResponse>;
